import makeStyles from '@mui/styles/makeStyles';

export const tableStyles = makeStyles((theme) => ({
	tableRow: {
		cursor: 'pointer',
		textDecoration: 'none',
	},
	disabledLink: {
		color: theme.palette.grey[300],
		cursor: 'not-allowed',
	},
}));
